import { createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '../../lib/http'


export const getApiKeyByContactGroup = createAsyncThunk(
  'apiKeys/getByGroup',
  async ({ groupId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/contact-groups/${groupId}/api-key`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to get API key'
      return rejectWithValue(errorMessage)
    }
  }
)

export const createApiKey = createAsyncThunk(
  'apiKeys/create',
  async ({ groupId, defaultCreator }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/contact-groups/${groupId}/api-key`, {
        defaultCreator,
      })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to create API key'
      return rejectWithValue(errorMessage)
    }
  }
)

export const updateApiKey = createAsyncThunk(
  'apiKeys/update',
  async ({ groupId, defaultCreator }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(`/contact-groups/${groupId}/api-key`, {
        defaultCreator,
      })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to update API key'
      return rejectWithValue(errorMessage)
    }
  }
)

export const getContactGroupUsers = createAsyncThunk(
  'apiKeys/getGroupUsers',
  async ({ groupId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/contact-groups/${groupId}/users`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to fetch group users'
      return rejectWithValue(errorMessage)
    }
  }
)

export const removeApiKey = createAsyncThunk(
  'apiKeys/remove',
  async ({ groupId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.delete(`/contact-groups/${groupId}/api-key`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to revoke API key'
      return rejectWithValue(errorMessage)
    }
  }
)